<template>
  <div class="media-list">
    <div class="breadcrumb-bar">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/courseList' }"
          >特色课程管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>特色课程详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main-box">
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">特色课程基本信息</h3>
          <div class="panel-content">
            <el-form :inline="true" :model="showExtra" label-width="120px">
              <el-form-item label="特色课程名称:">
                <p>{{ showExtra.name }}</p>
              </el-form-item>
              <el-form-item label="特色课程ID:">
                <p>{{ showExtra.id }}</p>
              </el-form-item>
              <br />
              <el-form-item label="特色课程图片:">
                <img
                  v-if="showExtra.image != ''"
                  :src="showExtra.image"
                  width="80px"
                  height="80px"
                />
              </el-form-item>
              <br />
              <el-form-item label="数量:">
                <p>{{ showExtra.count }}</p>
              </el-form-item>
              <el-form-item label="级别:">
                <p>{{ showExtra.level }}</p>
              </el-form-item>
              <br />
            </el-form>
          </div>
        </div>
      </Card>
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">
            已添加书籍
            <span style="font-size: 14px">（可拖拽进行排序）</span>
          </h3>
          <div class="panel-content">
            <el-table
              ref="multipleTable"
              :data="bookData"
              stripe
              border
              row-key="id"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column
                prop="rid"
                label="书籍ID"
                align="center"
                min-width="120"
              >
                <template slot-scope="scope">
                  <a
                    href="javascript:;"
                    @click="viewBook(scope.row)"
                    style="color: #1d90e6"
                    >{{ scope.row.rid }}</a
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="书籍名称"
                align="center"
                width="180"
              >
                <template slot-scope="scope">
                  <a
                    href="javascript:;"
                    @click="viewBook(scope.row)"
                    style="color: #1d90e6"
                    >{{ scope.row.name }}</a
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="dbName"
                label="CP"
                align="center"
                min-width="110"
              ></el-table-column>
              <el-table-column
                prop="count"
                label="品牌"
                align="center"
                width="130"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.content.brand }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="updated_at"
                label="级别"
                align="center"
                width="130"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.content.level }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="排序"
                align="center"
                width="130"
                type="index"
              >
              </el-table-column>
              <el-table-column
                prop="clevel"
                label="上下架状态"
                align="center"
                min-width="120"
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.clevel == 0" type="danger"
                    >已下架</el-tag
                  >
                  <el-tag v-if="scope.row.clevel == 4" type="info"
                    >审核通过</el-tag
                  >
                  <el-tag v-if="scope.row.clevel == 5" type="success"
                    >已上架</el-tag
                  >
                  <el-tag v-if="scope.row.clevel == 2" type="primary"
                    >编辑中</el-tag
                  >
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="操作"
                show-overflow-tooltip
                align="center"
                width="160"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="shareBox(scope.row)"
                    >分享</el-button
                  >
                </template>
              </el-table-column> -->
            </el-table>
            <el-button
              type="danger"
              icon="delete2"
              @click="handleDelete"
              style="margin-top: 8px"
              >删除</el-button
            >
            <el-button type="primary" @click="shangxiajia(5)" icon="arrow-up"
              >上架</el-button
            >
            <el-button type="info" @click="shangxiajia(0)" icon="arrow-down"
              >下架</el-button
            >
          </div>
        </div>
      </Card>
      <el-button
        type="primary"
        style="margin-left: 43%; margin-top: 30px; margin-bottom: 50px"
        @click="lastStep"
        >上一步</el-button
      >
      <el-button type="primary" @click="confirmSubmit">确定</el-button>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogTableVisible"
      style="width: 50%; text-align: center; margin: 0 auto"
    >
      <p style="text-align: center; font-size: 16px; margin-bottom: 20px">
        分享绘本：<span>{{ bookName }}</span>
      </p>
      <el-button
        type="primary"
        size="large"
        style="margin: 0 auto"
        @click="doCopy()"
      >
        复制分享链接</el-button
      >
    </el-dialog>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
import Sortable from "sortablejs";
export default {
  name: "packageDetail",
  components: {},
  data() {
    return {
      showExtra: {
        id: "",
        name: "",
        level: "",
        image: "",
        count: 0,
      },
      bookData: [],
      currId: null,
      albumId: null,
      multipleSelection: [],
      pageTotal: 0,
      queryParams: {
        page: 1,
        pageSize: 500,
      },
      dialogTableVisible: false,
      url: "",
      mid: "",
      bookName: "",
    };
  },
  created() {
    if (this.$route.query.id != undefined) {
      this.currId = `${this.$route.query.id}`;
      this.albumId = `${this.$route.query.albumId}`;
      this.fetchExtraList().then((res) => {
        if (res != null) {
          let m = JSON.parse(res);
          this.showExtra.id = m.id;
          this.showExtra.name = m.name;
          this.showExtra.level = m.level;
          this.showExtra.image = m.image;
          this.showExtra.count = m.count;
          this.fetchBookRes();
        }
      });
    }
  },
  mounted() {
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    this.rowDrop();
  },
  watch: {},
  methods: {
    // 分享
    shareBox(data) {
      // this.$router.push({
      //   name: "audioShare",
      //   // query: {
      //   //   id: this.currId,
      //   // },
      // });
      // debugger
      this.dialogTableVisible = true;
      this.mid = data.mid;
      this.bookName = data.name;
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      console.log("tbody", tbody);
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.bookData.splice(oldIndex, 1)[0];
          _this.bookData.splice(newIndex, 0, currRow);

          // _this.bookData = _this.bookData.sort(function(a, b) {

          //   return a.sort - b.sort
          // })
          //   console.log(_this.bookData, 'sss')
        },
      });
    },
    doCopy() {
      // debugger
      // console.log(mid)
      // 分享接口
      let vm = this;
      var appId = this.$API.APPID;
      var params = {
        appId: appId, //必须
        bookId: this.mid, //必须，书籍ID
      };
      this.$axios
        .post("/edu/eduAdmin/book/create_share_url", params)
        .then((response) => {
          var m = response.data;
          if (m.rc == 0) {
            // debugger

            this.url = m.data.url; //测试
            // this.url = m.data.urls; //本地
            var name = this.url.substring(this.url.indexOf("=") + 1);
            console.log(name, "o0ooiuuuuijghjfghj");
            this.$copyText(this.url).then(
              function (e) {
                // debugger;
                alert("复制成功");
                vm.dialogTableVisible = false;
              },

              function (e) {
                alert("复制失败，请手动复制链接地址：\n" + e.text);
              }
            );
          } else {
            // alert(m.msg);
          }
        });
      // debugger
    },
    // 上架
    shangxiajia(clevel) {
      if (this.multipleSelection.length == 0) {
        alert("请先选择书籍");
        return;
      }
      let ids = [];
      for (let i in this.multipleSelection) {
        let temp = {
          dbId: this.multipleSelection[i].dbId,
          id: this.multipleSelection[i].rid,
        };
        ids.push(temp);
      }
      let param = {
        appId: this.$API.APPID,
        ids: ids,
        clevel: clevel,
      };
      this.sendUpDownBook(param).then((res) => {
        if (res == "success") {
          this.fetchBookRes();
        }
      });
    },
    sendUpDownBook(param) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("/aries-api/resource/online", param)
          .then((response) => {
            console.log(response);
            if (response.data.result == 0) {
              this.$Message.success("操作成功!");
              resolve(response.data.msg);
            } else {
              alert(response.data.msg);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    handleChange(va, v2, v3) {
      this.bookData[v3].ind = va;
      this.bookData.splice();
      // debugger
      // console.log(this.bookData, 'ss')
    },
    checkBookDataLen(array) {
      return new Set(array).size !== array.length;
    },
    fetchExtraList() {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
          id: this.currId,
        };
        this.eduAxiosPostRequest(
          "/edu/eduAdmin/course/extra_list",
          params
        ).then((res) => {
          if (res != null) {
            let m = JSON.parse(res);
            resolve(JSON.stringify(m.list[0]));
          } else {
            reject(null);
          }
        });
      });
    },
    fetchBookRes() {
      let params = {
        appId: this.$API.APPID,
        id: Number(this.albumId),
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
      };
      this.$axios
        .post("/aries-api/album/resList", params)
        .then((response) => {
          console.log(response);
          var m = response.data;
          if (m.result == 0) {
            this.bookData = m.data.list;
            this.pageTotal = m.data.pager.total;
            let startPageNum =
              (this.queryParams.page - 1) * this.queryParams.pageSize;
            let enableNum = 0;
            for (let i in this.bookData) {
              this.bookData[i].content = JSON.parse(this.bookData[i].content);
              this.bookData[i].ind = Number(i) + 1 + startPageNum;
              if (this.bookData[i].clevel == 5) {
                enableNum += 1;
              }
            }
            if (enableNum > 0) {
              if (this.showExtra.count == 0) {
                this.showExtra.count = enableNum;
              }
            }
            //console.log(this.bookData);
          } else {
            alert(m.msg);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    viewBook(book) {
      let routeUrl = this.$router.resolve({
        name: "addbook",
        query: {
          cpid: book.dbId,
          bookid: book.rid,
          do: "view",
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    lastStep() {
      this.$router.push({
        name: "extraAddNew",
        query: {
          id: this.currId,
        },
      });
    },

    confirmSubmit() {
      if (this.bookData.length > 0) {
        let res = [];

        // // 先判断bookData中是否存在相等的ind
        // var fiterInd = () => {
        //   var indList = this.bookData.map((item) => item.ind);
        //   // console.log(indList, 'int')
        //   return this.checkBookDataLen(indList);
        // };
        // if (fiterInd()) {
        //   alert("排序重复，请重新填写！");
        //   return;
        // }
        for (let i = 0; i < this.bookData.length; ++i) {
          let tmp = {
            id: this.bookData[i].rid,
            dbId: this.bookData[i].dbId,
            sort: i + 1,
          };
          res.push(tmp);
        }
        let params = {
          appId: this.$API.APPID,
          id: Number(this.albumId),
          resList: res,
        };
        // console.log(params)
        this.$axios
          .post("/aries-api/album/saveRes", params)
          .then((response) => {
            console.log(response);
            let m = response.data;
            if (m.result == 0) {
              this.$router.push({ name: "courseList" });
            } else {
              ApiMessage(this, m.err, "error");
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
          });
      } else if (this.bookData.length == 0) {
        this.$router.push({ name: "courseList" });
      }
    },
    handleDelete() {
       if (this.multipleSelection.length == 0) {
        alert("请先选择书籍");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除？",
        content: "<ul><li>请确认是否删除资源</li></ul>",
        onOk: () => {
          let len = this.multipleSelection.length;
          let resList = [];
          for (let i = 0; i < len; ++i) {
            let temp = {
              id: this.multipleSelection[i].rid,
              dbId: this.multipleSelection[i].dbId,
            };
            resList.push(temp);
          }
          let params = {
            appId: this.$API.APPID,
            id: Number(this.albumId),
            resList: resList,
          };
          this.$axios
            .post("/aries-api/album/delRes", params)
            .then((response) => {
              console.log(response);
              let m = response.data;
              if (m.result == 0) {
                this.fetchBookRes();
                this.$Message.success("删除成功!");
              } else {
                ApiMessage(this, m.err, "error");
              }
            })
            .catch((error) => {
              ApiMessage(this, error.toString(), "error");
            });
        },
      });
    },
    handleNumberChange(newIndex, book, oldIndex) {
      if (newIndex != null) {
        let changeNum = 0;
        oldIndex += 1;
        if (newIndex > oldIndex) {
          this.bookData.splice(newIndex, 0, book);
          this.bookData.splice(oldIndex - 1, 1);
          changeNum = newIndex - oldIndex;
          this.$nextTick(() => {
            for (let i = 0; i < changeNum; ++i) {
              let temp = this.bookData[i + oldIndex - 1];
              temp.ind = this.bookData[i + oldIndex - 1].ind - 1;
              this.$set(this.bookData, i + oldIndex - 1, temp);
            }
          });
        } else if (newIndex < oldIndex) {
          this.bookData.splice(newIndex - 1, 0, book);
          this.bookData.splice(oldIndex, 1);
          changeNum = oldIndex - newIndex;
          this.$nextTick(() => {
            for (let i = 0; i < changeNum; ++i) {
              let temp = this.bookData[i + newIndex];
              temp.ind = this.bookData[i + newIndex].ind + 1;
              this.$set(this.bookData, i + newIndex, temp);
            }
          });
        }
      }
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              resolve(JSON.stringify(response.data.data));
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less">
@import "../fyd-style";
@import "../commonEdu";
</style>


// WEBPACK FOOTER //
// myextra.vue?23d9d9fb